const API = process.env.REACT_APP_BACKEND_URL;
const BASE = `${API}/api/onboarding-vendor-invoice`;

export const viCall = async (path, token, body = {}) => {
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, ...body }),
  });
  const j = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof j.detail === 'string' ? j.detail : `Request failed (${res.status})`);
  return j;
};

export const viUpload = async (token, onboardingId, file) => {
  const fd = new FormData();
  fd.append('token', token); fd.append('onboarding_id', onboardingId); fd.append('file', file);
  const res = await fetch(`${BASE}/upload`, { method: 'POST', body: fd });
  const j = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(j.detail || 'Upload failed');
  return j;
};

export const viOpenFile = async (token, id) => {
  const res = await fetch(`${BASE}/file/${id}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token }),
  });
  if (!res.ok) throw new Error('File not available');
  window.open(URL.createObjectURL(await res.blob()), '_blank');
};

export const obPreview = async (token, kind, oid) => {
  const res = await fetch(`${API}/api/franchise-onboarding/${kind}-opening/preview/${oid}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token }),
  });
  return res.json();
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

export const CLASSES = ['ASSET', 'INVENTORY', 'CONSUMPTION', 'EXPENSE'];
